import { produce } from 'immer';

import { ShowImageInternalGalleryError } from '../../../actions/imageEditor/internal/showImageInternalGalleryError';
import { imageGalleryTextErrorMapper } from '../../../service/BannerEditErrors/ErrorsTextMapper/ErrorsTextMapper';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ValidationErrorData, ValidationResultItem } from '../../../typings/common';
import { ImageEditorsState } from '../../../typings/state';

export function showImageInternalGalleryError(
    state: ImageEditorsState,
    action: ShowImageInternalGalleryError
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].imageGallery.errors = action.errors.map(
            (error: ValidationResultItem): ValidationErrorData => ({
                code: error.code,
                path: error.path,
                text: imageGalleryTextErrorMapper(error)
            })
        );
    });
}
